document.addEventListener('DOMContentLoaded', () => {
  const bannerBtn = document.querySelector('.banner-btn');
  if (!bannerBtn) return;

  bannerBtn.addEventListener('click', e => {
    const targetId = bannerBtn.getAttribute('href');
    if (!targetId.startsWith('#')) return;

    const targetSection = document.querySelector(targetId);
    if (!targetSection) return;

    e.preventDefault();

    const headerOffset = window.innerWidth >= 1024 ? 48 : 44;
    const offsetTop =
      targetSection.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  });
});
